export default __webpack_public_path__ + "static/media/icon-loading.7dca0e6a.svg";